module.exports = __webpack_public_path__ + "img/20201014_120656.f9b60fe1.jpg";